import { Phone, MessageSquare, MessageCircle } from "lucide-react";

const PHONE_LINK = "tel:+17814756126";
const SMS_LINK = "sms:+17814756126";
const WHATSAPP_LINK = "https://wa.me/17814756126";

export const FloatingButtons = () => {
  return (
    <div data-testid="floating-buttons" className="fixed bottom-4 right-4 z-40 flex flex-col gap-3 md:hidden">
      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        className="w-12 h-12 flex items-center justify-center bg-green-500 text-white shadow-lg shadow-green-500/30 transition-transform duration-200 active:scale-95 rounded-full"
        aria-label="WhatsApp"
      >
        <MessageCircle className="w-5 h-5" strokeWidth={2} />
      </a>
      <a
        href={SMS_LINK}
        data-testid="floating-sms"
        className="w-12 h-12 flex items-center justify-center bg-teal text-black shadow-lg shadow-teal/30 transition-transform duration-200 active:scale-95 rounded-full"
        aria-label="SMS"
      >
        <MessageSquare className="w-5 h-5" strokeWidth={2} />
      </a>
      <a
        href={PHONE_LINK}
        data-testid="floating-call"
        className="w-12 h-12 flex items-center justify-center bg-gold text-black shadow-lg shadow-gold/30 transition-transform duration-200 active:scale-95 animate-pulse-glow rounded-full"
        aria-label="Call"
      >
        <Phone className="w-5 h-5" strokeWidth={2} />
      </a>
    </div>
  );
};
